import { ValidationModel, ValidationType } from "@/services/validation/types";

export const propertiesValidators = {
    language: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel,
    format: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel,
    timeZone: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel
};
